import script from "./Servicios.vue?vue&type=script&setup=true&lang=js"
export * from "./Servicios.vue?vue&type=script&setup=true&lang=js"

import "./Servicios.vue?vue&type=style&index=0&id=6c337d3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c337d3b"]])

export default __exports__